import DispatchConstants from '../constants/DispatchConstants';

const initState = () => ({
  settings: [],
});

const notification = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.NOTIFICATION_SETTINGS_GET_SUCCESS:
      return Object.assign({}, state, payload);

    default:
      return state;
  }
};

export default notification;
